import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/Form.api';
export const getFormRequest = (unit_id) => ({
  type: actionTypes.GET_FORM_REQUEST,
  payload: unit_id,
});

export const getFormSuccess = (Form) => ({
  type: actionTypes.GET_FORM_SUCCESS,
  payload: Form,
});

export const getFormFailure = (error) => ({
  type: actionTypes.GET_FORM_FAILURE,
  payload: error,
});

export const getForm = (unit_id) => {
  return async (dispatch) => {
    dispatch(getFormRequest());
    try {
      const Form = await api.fetchform(unit_id);
      dispatch(getFormSuccess(Form));
      return { success: true, data: Form };
    } catch (error) {
      dispatch(getFormFailure(error));
      return { success: false, message: error };
    }
  };
};
export const getInputMatrixActivitiesRequest = () => ({
  type: actionTypes.GET_getInputMatrixActivities_REQUEST
});

export const getInputMatrixActivitiesSuccess = (data) => ({
  type: actionTypes.GET_getInputMatrixActivities_SUCCESS,
  payload: data,
});

export const getInputMatrixActivitiesFailure = (error) => ({
  type: actionTypes.GET_getInputMatrixActivities_FAILURE,
  payload: error,
});

export const getInputMatrixActivities = () => {
  return async (dispatch) => {
    dispatch(getFormRequest());
    try {
      const Form = await api.fetchgetInputMatrixActivities();
      dispatch(getInputMatrixActivitiesSuccess(Form));
      return { success: true, data: Form };
    } catch (error) {
      dispatch(getInputMatrixActivitiesFailure(error));
      return { success: false, message: error };
    }
  };
};


// export const getGeneratedFormRequest = () => ({
//   type: actionTypes.GET_GENERATED_FORM_REQUEST,
// });

// export const getGeneratedFormSuccess = (emp_separation) => ({
//   type: actionTypes.GET_GENERATED_FORM_SUCCESS,
//   payload: emp_separation,
// });

// export const getGeneratedFormFailure = (error) => ({
//   type: actionTypes.GET_GENERATED_FORM_FAILURE,
//   payload: error,
// });

// export const getGeneratedForm = (date) => {
//   return async (dispatch) => {
//     dispatch(getGeneratedFormRequest(date));
//     try {
//       const emp_separation = await api.fetchGeneratedFormData(date);
//       dispatch(getGeneratedFormSuccess(emp_separation));
//       return { success: true, data: emp_separation };
//     } catch (error) {
//       dispatch(getGeneratedFormFailure(error));
//       return { success: false, message: error };
//     }
//   };
// };


// export const updateGeneratedFormRequest = (id, GeneratedFormData) => ({
//   type: actionTypes.UPDATE_GENERATED_FORM_REQUEST,
//   payload: { id, GeneratedFormData },
// });

// export const updateGeneratedFormSuccess = (message) => ({
//   type: actionTypes.UPDATE_GENERATED_FORM_SUCCESS,
//   payload: message,
// });

// export const updateGeneratedFormFailure = (error) => ({
//   type: actionTypes.UPDATE_GENERATED_FORM_FAILURE,
//   payload: error,
// });


// export const updateGeneratedFormById = (id, GeneratedFormData) => {
//   return async (dispatch) => {
//     const user = JSON.parse(sessionStorage.getItem('user'));
//     GeneratedFormData.updated_by = user.user_name;

//     dispatch(updateGeneratedFormRequest(id, GeneratedFormData));
//     try {
//       const response = await api.updateGeneratedForm(id, GeneratedFormData);
//       dispatch(updateGeneratedFormSuccess(response.message));
//       return { success: true, message: response.message };
//     } catch (error) {
//       dispatch(updateGeneratedFormFailure(error));
//       return { success: false, message: error };
//     }
//   };
// };


// export const deleteGeneratedFormRequest = (id) => ({
//   type: actionTypes.DELETE_GENERATED_FORM_REQUEST,
//   payload: id,
// });

// export const deleteGeneratedFormSuccess = (message) => ({
//   type: actionTypes.DELETE_GENERATED_FORM_SUCCESS,
//   payload: message,
// });

// export const deleteaternityBenefitsFailure = (error) => ({
//   type: actionTypes.DELETE_GENERATED_FORM_FAILURE,
//   payload: error,
// });



// export const deleteGeneratedFormById = (id) => {
//   return async (dispatch) => {
//     dispatch(deleteGeneratedFormRequest(id));
//     try {
//       const response = await api.deleteGeneratedForm(id);
//       dispatch(deleteGeneratedFormSuccess(response.message));
//       return { success: true, message: response.message };
//     } catch (error) {
//       dispatch(deleteaternityBenefitsFailure(error));
//       return { success: false, message: error };
//     }
//   };
// };


// export const uploadGeneratedFormRequest = (fileData) => ({
//   type: actionTypes.UPLOAD_GENERATED_FORM_REQUEST,
//   payload: fileData,
// });

// export const uploadGeneratedFormSuccess = (message) => ({
//   type: actionTypes.UPLOAD_GENERATED_FORM_SUCCESS,
//   payload: message,
// });

// export const uploadGeneratedFormFailure = (error) => ({
//   type: actionTypes.UPLOAD_GENERATED_FORM_FAILURE,
//   payload: error,
// });


// export const uploadGeneratedFormFile = (fileData) => {
//   return async (dispatch) => {
//     dispatch(uploadGeneratedFormRequest(fileData));
//     try {
//       const response = await api.upload_Emp_separation(fileData);
//       dispatch(uploadGeneratedFormSuccess(response));
//       return { success: true, message: response };
//     } catch (error) {
//       dispatch(uploadGeneratedFormFailure(error));
//       return { success: false, message: error };
//     }
//   };
// };









